/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SocialInteractionTargetFragment = {
  __typename: 'SocialInteractionTarget';
  urn: string;
  commentsCount: number;
  repliesCount: number;
  reactionsCount: number;
  sharesCount: number;
  userReactionType?: Types.SocialReactionType | null;
  id: string;
  permissions: {
    __typename: 'SocialPermissions';
    reactions: {
      __typename: 'SocialReactionPermissions';
      canCreate: boolean;
      canView: boolean;
      canDelete: boolean;
    };
    comments: {
      __typename: 'SocialCommentPermissions';
      canCreate: boolean;
      canUpdate: boolean;
      canView: boolean;
      canDelete: boolean;
      canDeleteMentions: boolean;
    };
    shares: {
      __typename: 'SocialSharePermissions';
      canCreate: boolean;
      canView: boolean;
      canDelete: boolean;
    };
    mentions: { __typename: 'SocialMentionPermissions'; canDelete: boolean };
  };
};

export const SocialInteractionTargetFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SocialInteractionTarget' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SocialInteractionTarget' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'id' },
            name: { kind: 'Name', value: 'urn' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'urn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'commentsCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repliesCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reactionsCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sharesCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userReactionType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SocialPermissions' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SocialPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SocialPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canCreate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canView' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDelete' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canCreate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canUpdate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canView' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDelete' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canDeleteMentions' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shares' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canCreate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canView' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDelete' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDelete' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SocialInteractionTargetFragment, unknown>;
